import React from 'react';
import { connect } from 'react-redux';
import Headline from '../components/atoms/Headline';
import PaymentSelectorGroup from '../components/molecules/PaymentSelectorGroup';
import { setPayment, resetPayment } from '../actions/status';
import { showNextButton } from '../actions/next';
import { beautifyPrice } from '../utils';

var AppConfig = require('../config.json');


class PaymentView extends React.Component {
    constructor(props) {
      super(props);
      this.findConfiguration = this.findConfiguration.bind(this);
      this.selectGroup = this.selectGroup.bind(this);
      this.selectOption = this.selectOption.bind(this);
      this.isSelectedGroup = this.isSelectedGroup.bind(this);
      this.getPayments = this.getPayments.bind(this);
      this.groups = {};
      this.state = {
        id: '',
        type: '',
        paymentOption:'',
        paymentPrice:'',
        paymentRuntime:0,
        group:'',
        bundleId: 0,
        isset: false
      };
    }



    getPayments(bundle) {
      var arr = [], stdPurchase = [], payeverPurchase = [], mk = {}, mke = {};
      if(bundle.payments.hasOwnProperty('mk')) {
        mk = {group:'financing', id:'mk', type:'mk', data: bundle.payments.mk};
      }
      if(bundle.payments.hasOwnProperty('mke')) {
        mke = {group:'financing', id:'mke', type:'mke', data: bundle.payments.mke};
      }
      if(bundle.payments.hasOwnProperty('sf')) {
        payeverPurchase.push({ type: 'sf', price: bundle.payments.sf.price});
      }
      if(bundle.payments.hasOwnProperty('sk')) {
        stdPurchase.push({type:'sk', price: bundle.payments.sk});
      }
      if(bundle.payments.hasOwnProperty('vk')) {
        stdPurchase.push({type:'vk', price: bundle.payments.vk});
      }
      if(bundle.payments.hasOwnProperty('ls')) {
        stdPurchase.push({type:'ls', price: bundle.payments.ls});
      }
      if(bundle.payments.hasOwnProperty('rg')) {
        stdPurchase.push({type:'rg', price: bundle.payments.rg});
      }
      if(bundle.payments.hasOwnProperty('sos')) {
        stdPurchase.push({type:'sos', price: bundle.payments.sos});
      }
      if(stdPurchase.length) {
        if(bundle.payments.hasOwnProperty('sos')) {
          arr.push({group:'purchase', type:'sos', id:'sos', data: stdPurchase});
        } else {
          arr.push({group:'purchase', type:'pc', id:'pc', data: stdPurchase});
        }
      }
      if(payeverPurchase.length) {
        arr.push({ group: 'payever', type: 'sf', id: 'sf', rejected: this.props.rejected, data: payeverPurchase});
      }
      if(mk.hasOwnProperty('group')) {
        arr.push(mk);
      }
      if(mke.hasOwnProperty('group')) {
        arr.push(mke);
      }
      return arr;
    }

    componentDidMount() {
      // if(this.props.pathname==="/"+AppConfig.links.payment.url && (this.props.linkTo===AppConfig.links.payment.url || this.props.linkTo==="")) {
        this.props.dispatch(showNextButton({link: AppConfig.links.order.url, label: 'Weiter', watch: 'payment', submitDelay:200}));
      // }
      const bundle = this.props.project.data.bundles.find(this.findConfiguration);
      const payments = bundle!==undefined ? this.getPayments(bundle) : [];

      var paymentId = this.props.payment.id;
      var group = this.props.payment.group;
      if(paymentId==='' && payments.length===1) {
        paymentId = payments[0].id;
      }
      if(group==='' && payments.length===1) {
        group = payments[0].group;
      }
      var isset = (this.props.payment.id!=='' && this.props.payment.type!=='' && this.props.bundle.id!==0);
      
      this.setState({
        id: paymentId,
        type: this.props.payment.type,
        paymentOption: this.props.payment.paymentOption,
        paymentPrice: this.props.payment.paymentPrice,
        paymentRuntime: this.props.payment.paymentRuntime,
        bundleId: this.props.bundle.id,
        group:group,
        isset: isset
      });
      if(!isset && this.props.payment.isset) {
        this.props.dispatch(resetPayment());
      } else {
        if(this.props.rejected && this.props.payment.type==='sf') {
          this.props.dispatch(resetPayment());
        }
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      return this.props.pathname===nextProps.pathname;
    }

    componentWillUpdate(nextProps, nextState) {
      if(this.state.id!==nextState.id && this.state.id!=='' && this.props.payment.isset) {
        this.props.dispatch(resetPayment());
      }
      
    }

    selectOption(group, option) {
      var newState = {
        id: group.id,
        type:option.payment,
        paymentOption:option.paymentOption,
        paymentPrice:option.paymentPrice,
        paymentRuntime:option.paymentRuntime,
        bundleId:this.props.bundle.id,
        group:group.group,
        isset:true
      };
      this.setState(newState, function() {
        this.props.dispatch(setPayment(
          this.state
        ));
      });
    }

    selectGroup(group) {
      this.setState({
        id: group.id,
        type:'',
        paymentOption:'',
        paymentPrice:'',
        paymentRuntime:0,
        group:group.group,
        isset:false
      });
    }

    isSelectedGroup(group) {
      return this.state.id===group.id;
    }

    findConfiguration(bundle) { 
      return this.props.bundle.id === bundle.id;
    }

    render () {
        const bundle = this.props.project.data.bundles.find(this.findConfiguration);
        const payments = bundle!==undefined ? this.getPayments(bundle) : [];
        return (
          <div className="contentview payment">
          {this.props.options.isset?
              <div>
              <div className="header">
                <Headline typeOf="h3">Bitte wählen Sie Ihre Vertragsart:</Headline>
              </div> 
              { bundle.sponsoring.active && 
              <div className="sponsoring">
                <p>Hinweis: Es wird nur der Eigenanteil über <span dangerouslySetInnerHTML={{__html:beautifyPrice(bundle.sponsoring.customerPrice)}} /> € zur Berechnung des Preises angewendet.</p>
              </div> 
             }
              <div className="groups">
                  {
                    bundle!==undefined
                    ?
                    payments.map((config, n) => <PaymentSelectorGroup ref={`paymentgroup_${n}`} key={`paymentgroup_${n}`} group={`paymentgroup_${n}`} config={config} onChangeGroup={this.selectGroup} onChangeOption={this.selectOption} isOnlyPayment={payments.length===1} selected={this.isSelectedGroup(config)} />)
                      
                    :
                    null
                  }
            </div>
            </div>
            :null}
          </div>
        );
    }

}




const mapStateToProps = (state) => {
  return {
    pathname: state.routing.location.pathname,
    linkTo: state.content.link,
    project: state.status.project,
    options: state.status.options,
    bundle: state.status.bundle,
    payment: state.status.payment,
    rejected: state.payever.rejected
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentView)


// WEBPACK FOOTER //
// ./src/views/PaymentView.js